<template>
  <div class="container page" style="background: url(/img/home/g.f7e76bcc.png) repeat top / 100% auto;;padding-bottom: 20px;">
    <van-nav-bar :title="$t('recharge.recharge')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
      <template #right>
        <span class="nav-right" style="color:#fff" @click="$router.push({path:'/RechargeRecord'})">{{$t("foorter.ti_record")}}</span>
      </template>
    </van-nav-bar>
	<div style="padding: 0 12px;box-sizing: border-box;padding-top:20px;background: #fff;padding-bottom: 40px;">
		<div v-if="class2">
			<div style="width:180px;height: 180px;margin: 0 auto;border-radius:10px;padding:10px;overflow: hidden;">
				<img :src="withdrawRole.usdtimg" style="width:160px;height: 160px;display: inline-block">
			</div>
			<div style="text-align: center;margin:10px 0;">
				<div style="margin-bottom:10px;">[USDT] - [TRC20]</div>
			</div>
			<div style="width: 100%;line-height: 30px;font-size: 14px;text-align: left;padding-left: 5px;color: #999">
				{{$t("my.msg40")}}
			</div>
			<div style="background: #fff;box-shadow: 0 0 10px 0 #e9e9e9;border-radius: 4px;height: 40px;">
				<div style="overflow: visible;osition: relative;overflow: hidden;color: #323233;text-align: left;vertical-align: middle;word-wrap: break-word;">
					<div style="display: flex;-webkit-box-align: center;-webkit-align-items: center;-ms-flex-align: center;align-items: center;">
						<div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width:85%;font-size: 14px;line-height:40px;color: #000;padding-left: 10px;">
							{{withdrawRole.usdt}}
						</div>
						<div style="padding-left:8px;margin-right:10px" @click="copys(withdrawRole.usdt)">
							<span style="color: rgb(102, 102, 102);font-size: 16px;text-align: left">Copy</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-if="class1">
			<div style="width: 100%;line-height: 30px;font-size: 14px;text-align: left;padding-left: 5px;color: #999">
				{{$t("setting.username")}}
			</div>
			<div style="background: #fff;box-shadow: 0 0 10px 0 #e9e9e9;border-radius: 4px;height: 40px;">
				<div style="overflow: visible;osition: relative;overflow: hidden;color: #323233;text-align: left;vertical-align: middle;word-wrap: break-word;">
					<div style="display: flex;-webkit-box-align: center;-webkit-align-items: center;-ms-flex-align: center;align-items: center;">
						<div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width:85%;font-size: 14px;line-height:40px;color: #000;padding-left: 10px;">
							{{withdrawRole.names}}
						</div>
						<div style="padding-left:8px;margin-right:10px;" @click="copys(withdrawRole.names)">
							<span style="color: rgb(102, 102, 102);font-size: 16px;text-align: left">Copy</span>
						</div>
					</div>
				</div>
			</div>
			<div style="width: 100%;line-height: 30px;font-size: 14px;text-align: left;padding-left: 5px;color: #999">
				{{$t("setting.band_name")}}
			</div>
			<div style="background: #fff;box-shadow: 0 0 10px 0 #e9e9e9;border-radius: 4px;height: 40px;">
				<div style="overflow: visible;osition: relative;overflow: hidden;color: #323233;text-align: left;vertical-align: middle;word-wrap: break-word;">
					<div style="display: flex;-webkit-box-align: center;-webkit-align-items: center;-ms-flex-align: center;align-items: center;">
						<div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width:85%;font-size: 14px;line-height:40px;color: #000;padding-left: 10px;">
							{{withdrawRole.bankname}}
						</div>
						<div style="padding-left:8px;margin-right:10px" @click="copys(withdrawRole.bankname)">
							<span style="color: rgb(102, 102, 102);font-size: 16px;text-align: left">Copy</span>
						</div>
					</div>
				</div>
			</div>
			<div style="width: 100%;line-height: 30px;font-size: 14px;text-align: left;padding-left: 5px;color: #999">
				{{$t("setting.branch_name")}}
			</div>
			<div style="background: #fff;box-shadow: 0 0 10px 0 #e9e9e9;border-radius: 4px;height: 40px;">
				<div style="overflow: visible;osition: relative;overflow: hidden;color: #323233;text-align: left;vertical-align: middle;word-wrap: break-word;">
					<div style="display: flex;-webkit-box-align: center;-webkit-align-items: center;-ms-flex-align: center;align-items: center;">
						<div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width:85%;font-size: 14px;line-height:40px;color: #000;padding-left: 10px;">
							{{withdrawRole.fname}}
						</div>
						<div style="padding-left:8px;margin-right:10px" @click="copys(withdrawRole.fname)">
							<span style="color: rgb(102, 102, 102);font-size: 16px;text-align: left">Copy</span>
						</div>
					</div>
				</div>
			</div>
			<div style="width: 100%;line-height: 30px;font-size: 14px;text-align: left;padding-left: 5px;color: #999">
				{{$t("setting.branch_code")}}
			</div>
			<div style="background: #fff;box-shadow: 0 0 10px 0 #e9e9e9;border-radius: 4px;height: 40px;">
				<div style="overflow: visible;osition: relative;overflow: hidden;color: #323233;text-align: left;vertical-align: middle;word-wrap: break-word;">
					<div style="display: flex;-webkit-box-align: center;-webkit-align-items: center;-ms-flex-align: center;align-items: center;">
						<div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width:85%;font-size: 14px;line-height:40px;color: #000;padding-left: 10px;">
							{{withdrawRole.fnum}}
						</div>
						<div style="padding-left:8px;margin-right:10px" @click="copys(withdrawRole.fnum)">
							<span style="color: rgb(102, 102, 102);font-size: 16px;text-align: left">Copy</span>
						</div>
					</div>
				</div>
			</div>
			<div style="width: 100%;line-height: 30px;font-size: 14px;text-align: left;padding-left: 5px;color: #999">
				{{$t("setting.band_account")}}
			</div>
			<div style="background: #fff;box-shadow: 0 0 10px 0 #e9e9e9;border-radius: 4px;height: 40px;">
				<div style="overflow: visible;osition: relative;overflow: hidden;color: #323233;text-align: left;vertical-align: middle;word-wrap: break-word;">
					<div style="display: flex;-webkit-box-align: center;-webkit-align-items: center;-ms-flex-align: center;align-items: center;">
						<div style="overflow: hidden;white-space: nowrap;text-overflow: ellipsis;width:85%;font-size: 14px;line-height:40px;color: #000;padding-left: 10px;">
							{{withdrawRole.cardnum}}
						</div>
						<div style="padding-left:8px;margin-right:10px" @click="copys(withdrawRole.cardnum)">
							<span style="color: rgb(102, 102, 102);font-size: 16px;text-align: left">Copy</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div style="margin-top:10px;padding: 10px 0;border-radius:10px;background-color: #fff;">
			<div style="width: 100%;line-height: 30px;font-size: 14px;text-align: left;">
				{{$t("recharge.pay_way")}}
			</div>
			<div style="width: 100%;height: 30px;margin-bottom: 5px;margin-top: 5px;">
				<div style="width: 40%;float: left;margin-left: 7%;height: 30px;display: flex; /* 将父容器设置为 Flexbox */
			justify-content: center;
			align-items: center;">
					<div @click="history(1)" :class="class1?'aaitce':''" style="margin: 0 auto;height: 30px;line-height: 30px;font-size: 14px;font-weight: 700;width:100%;background: #d9d9d9;border-radius: 10px;text-align: center;">{{$t("my.msg50")}}</div>
				</div>
				<div style="width: 40%;float: right;margin-right: 7%;height: 30px;display: flex; /* 将父容器设置为 Flexbox */
			justify-content: center;
			align-items: center;">
					<div @click="history(2)" :class="class2?'aaitce':''" style="margin: 0 auto;height: 30px;line-height: 30px;font-size: 14px;font-weight: 700;width:100%;background: #d9d9d9;border-radius: 10px;text-align: center;">{{$t("my.msg51")}}</div>
				</div>
				<div style="clear:both"></div>
			</div>
			<div style="margin-top: 15px;position: relative;display: -webkit-box;display: -webkit-flex;display: -ms-flexbox;display: flex;box-sizing: border-box;width: 100%;padding:10px 16px;overflow: hidden;color: #323233;font-size:14px;line-height:24px;background-color: #fff;">
				<div style="margin-right:4px;">
					<div style="margin-right:10px">
						<img style="width:20px;height:20px" src="/img/home/q.png">
					</div>
				</div>
				<div style="display: flex;-webkit-box-align: center;align-items: center;">
					<van-field type="number" style=";display: block;box-sizing: border-box;width: 80%;min-width: 0;margin: 0;padding: 0;color: #323233;line-height: inherit;text-align: left;background-color: transparent;border: 0;resize: none;" v-model="withdraw_money" :value="this.withdraw_money" :placeholder="$t('recharge.input_money')"/>
				</div>
			</div>
			<div style="background: #d6d6d6;margin:10px auto;padding:20px 10px;text-align: center;">
				<div style="position: relative;display: inline-block">
					<div style="display: flex;flex-wrap: wrap;">
						<van-uploader v-model="fileList" multiple :max-count="1" :after-read="afterRead"><van-icon name="photograph" size="32px" /></van-uploader>
					</div>
				</div>
				<!-- <div class="upload_">
					<van-uploader v-model="fileList" multiple :max-count="1" :after-read="afterRead"/>
					{{$t('msg.scfkjt')}}
				</div> -->
				<div style="padding:10px 0;font-size:16px;color: #000;">
					{{$t("my.msg59")}}
				</div>
			</div>
			
		</div>
		<div style="padding:5px 16px;width:100%">
			<div @click="doWithdraw()" style="border-radius: 10px;;font-size: 16px;;text-align: center;;line-height: 46px;;width: 100%;height:46px;color: white;background: linear-gradient(180deg, #fc78af, #f22678);border-color: rgb(156, 206, 109);">
				{{$t("my.msg58")}}
			</div>
		</div>
	</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showPopover: false,
      withdraw_money:"",type:2,class1:false,class2:true,img:"",content:"",fileList:[],
      userInfo:{},formData: {
        file: null, // 文件字段
      },
      withdrawRole:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
	afterRead(event){
		console.log(event.content);
this.$http({
          method: 'post',
          data:{content:event.content},
          url: 'upimg'
        }).then(res=>{
          if(res.code === 200){
            //location. reload()
			this.img=res.data.img;
            this.$toast(res.msg);
          }else if(res.code ===401){
            this.$toast(res.msg);
          }
        })
	},getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
          this.name = res.data.name;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },async copys(e) {
      try {
        // Use navigator.clipboard.writeText to copy text
        await navigator.clipboard.writeText(e);

		this.$toast("Copy successful");
      } catch (error) {
        console.error("Failed to copy text: ", error);
		this.$toast("Replication failed");
      }
    },history(e){
		if(e==1){
				this.class1=true;
				this.class2=false;
			
		}else{
				this.class1=false;
				this.class2=true;
		}
		this.type=e;
	},num(e){
		this.withdraw_money=e;
	},
    getUserWithdrawRole(){
      this.$http({
        method: 'get',
        url: 'user_get_recharge_role'
      }).then(res=>{
        if(res.code === 200){
          this.withdrawRole = res.data;this.bank=res.data.bank;this.usdt=res.data.usdt;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    doWithdraw(){
      if(this.withdraw_money <= 0){
        this.$toast(this.$t("recharge.input_money"));
        return false;
      }else {
		if(this.type==''){
			this.$toast(this.$t("my.msg57"));
			return false;
		}
		if(this.img==''){
			this.$toast(this.$t("my.msg59"));
			return false;
		}
        this.$http({
          method: 'post',
          data:{money:this.withdraw_money,type:this.type,img:this.img},
          url: 'user_set_recharge'
        }).then(res=>{
          if(res.code === 200){
            this.$toast(res.msg);
             this.$router.push({path:'/RechargeRecord'});
          }else if(res.code ===401){
            this.$toast(res.msg);
          }
        })
      }
    },
    withdrawInfo(){
      this.showPopover = true;
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserWithdrawRole();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.van-cell {
  font-size: 35px;
  line-height: 80px;
}.aaitce{background: linear-gradient(180deg, #fc78af, #f22678) !important;color: #fff;}
.container p{
  padding: 0 15px;
  margin-top: 15px;
  font-size: 30px;
  color: #dc2037;
}.upload_{
	padding: 60px 0;
	margin: 40px 0;
	width: 100%;
	text-align: center;
	background-color: #efefef;
	display: flex;
	flex-direction: column;
}
.van-uploader{
	.van-uploader__upload{
		width: 200px;
		height: 200px;
		
	}
	.van-uploader__wrapper{
		justify-content: center;
	}
}
.container .main{
  display: flex;
  flex-direction: column;
  background-color: #f2f2f5;
  height: calc(100% - 50px);
  position: relative;
}
.container .main .withdrawMoney{
  display: flex;
  flex-direction: column;
  color: #000;
  padding: 0 20px;
  white-space: nowrap;
  font-size: 35px;
  background-color: #fff;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money{
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  border-bottom: 1px solid #f2f2f5;
}
.container .main .withdrawMoney .money .moneyNumber{
  font-size: 50px;
  display: flex;
  flex-direction: row;
}
.container .main .withdrawMoney span {
  padding: 10px 0;
}
.container .main .withdrawMoney .money .all{
  color: #d10404;
}
.container .main .withdrawMoney .money .moneyNumber .van-cell {
  font-size: 50px;
  padding: 0!important;
}
.container .main .withdrawMoney .information{
  padding-bottom: 30px;
}
.container .main .withdrawMoney .information .description {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 10px 0;
}
.container .main .withdrawMoney span{
  padding: 10px 0;
}.nav-bar{background: linear-gradient(180deg, #fc78af, #f22678);}
.container .main .withdrawMoney .information .balance .number{
  color: #d10404;
}
.withdraw_btn {
  margin: 20px 30px 0;
  height: 80px;
  line-height: 1.22667rem;
  border-radius: 50px;
  color: #fff;
  font-size: 30px;
  font-weight: bolder;
  border: none;
  background: linear-gradient(
      90deg,#e6c3a1,#7e5678);
}
</style>
